import React, { useEffect, useState } from 'react';
import PlanStore from './PlanStore';
import LoginModal from '../../components/LoginModal/LoginModal';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../../services/api';
import { useAuth } from '../../contexts/AuthContext';
import axios from 'axios';

const CheckoutPage = () => {
    const [paymentMethod, setPaymentMethod] = useState('card');
    const [coupon, setCoupon] = useState('SAVE20');
    const { selectedPlan, setSelectedPlan, clearSelectedPlan } = PlanStore();
    const [loading, setLoading] = useState(false);
    const [showLoginModal, setShowLoginModal] = useState(false);
    const { isAuthenticated, user, createOrder, verifyOrder } = useAuth();
    const [billingCycle, setBillingCycle] = useState('monthly');
    const [paymentStatus, setPaymentStatus] = useState("");
    const [paymentResp, setPaymentResp] = useState("");
    const navigate = useNavigate();

    const planPrice = selectedPlan?.price?.monthly || 0; // 999
    const gstRate = 18;
    const discountPercentage = selectedPlan.discount || 10; // e.g. 10%

    const gstAmount = Math.round((planPrice * gstRate) / 100);
    const discountAmount = Math.round((planPrice * discountPercentage) / 100);

    const total = planPrice + gstAmount - discountAmount;

    useEffect(() => {
        console.log("Selected Plan:", selectedPlan, user);
}, [selectedPlan, navigate]);


    const handleSubscribe = async (planType) => {
        console.log('handleSubscribe called with planType:', planType);
        console.log('isAuthenticated:', isAuthenticated);
        setShowLoginModal(true);
        return;

        if (!isAuthenticated) {
            setShowLoginModal(true);

            return;
        }

        console.log('User is authenticated, proceeding with subscription');

        if (planType === 'free') {
            toast.info('You are already on the free plan');
            return;
        }

        await handleSubmitCreateSubscription(planType);
    };

    const handleRoute = (route) => {
        navigate(route);
    };
    const handleLoginSuccess = () => {
        if (selectedPlan) {
            setShowLoginModal(false);
            handleSubmitCreateSubscription(selectedPlan);
            setSelectedPlan(selectedPlan);
        }
    };

    const handleSubmitCreateSubscription = async (e) => {
        console.log("e", e)
        setShowLoginModal(false);

        // return false;
        // alert(localStorage.getItem("token"))
        // e.preventDefault()
        try {

            let payload = {
                amount: total,
                planType: selectedPlan.type,
                billingCycle: "monthly",
            }

            const response = await createOrder(payload);

            // toast.success('Login successful!');
            // navigate('/app/dashboard');

            // const response = await axios.post(
            //     "https://dev.whiterobe.in/api_ppm/api/v1/subscriptions/create",
            //     {
            //         amount: 1,
            //         planType: "basic",
            //         billingCycle: "monthly",
            //     },
            //     {
            //         headers: {
            //             Authorization: `Bearer ${localStorage.getItem("token")}`,
            //             "Content-Type": "application/json"
            //         }
            //     }
            // );

            console.log(response);
            openRazorpay(response)
            // alert(3)
        } catch (error) {
            console.error(error.response?.data || error.message);
            alert(2)
        }
    };
    const openRazorpay = (data) => {

        console.log("===order===", data)
        const options = {
            // key: process.env.REACT_APP_RAZORPAY_KEY_ID,
            key: data.key,
            amount: data.order.amount,
            currency: data.order.currency,
            name: "YesPPM",
            description: "Subscription",
            order_id: data.order.id,

            handler: async function (response) {
                console.log(response);
                try {
                    const orderResponse = await verifyOrder(response);
                    setPaymentResp(orderResponse)
                    console.log("paymentResp",paymentResp)
                    setPaymentStatus("success");
                } catch (error) {
                    setPaymentStatus("failed");
                    console.error(error.response?.data || error.message);
                    alert(2)
                }


                // Send to backend for verification
                // await axios.post("https://dev.whiterobe.in/api_ppm/api/v1/subscriptions/verify",
                //     response,
                //     {
                //         headers: {
                //             Authorization: `Bearer ${localStorage.getItem("token")}`,
                //             "Content-Type": "application/json"
                //         }
                //     }
                // );
            },

            prefill: {
                name: "Siva",
                email: "sivakumarp1440@gmail.com",
                contact: "9052363777"
            },

            theme: {
                color: "#1976d2"
            }
        };

        const razorpay = new window.Razorpay(options);
        razorpay.open();
    };




    return (



        <div className="min-h-screen bg-slate-50 py-10 px-4 sm:px-6 lg:px-8 text-slate-800">
            <LoginModal
                isOpen={showLoginModal}
                onClose={() => setShowLoginModal(false)}
                onSuccess={handleLoginSuccess}
            />

            {paymentStatus ? (
                <div className="flex justify-center">
                    <div
                        className={`<div className="mx-auto w-full max-w-lg rounded-2xl overflow-hidden border shadow-xl">`}
                    >
                        {/* Header */}
                        <div
                            className={`px-6 py-8 text-center ${paymentStatus === "success"
                                ? "bg-gradient-to-r from-green-500 to-emerald-600"
                                : "bg-gradient-to-r from-red-500 to-rose-600"
                                }`}
                        >
                            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-white shadow-lg">
                                <i
                                    className={`fas text-4xl ${paymentStatus === "success"
                                        ? "fa-check-circle text-green-500"
                                        : "fa-times-circle text-red-500"
                                        }`}
                                ></i>
                            </div>

                            <h2 className="mt-4 text-2xl font-bold text-white">
                                {paymentStatus === "success"
                                    ? "Payment Successful"
                                    : "Payment Failed"}
                            </h2>

                            <p
                                className={`mt-2 text-sm ${paymentStatus === "success"
                                    ? "text-green-100"
                                    : "text-red-100"
                                    }`}
                            >
                                {paymentStatus === "success"
                                    ? `Thank you for subscribing to ${selectedPlan?.name}.`
                                    : `We couldn't process your payment for ${selectedPlan?.name}.`}
                            </p>
                        </div>

                        {/* Summary */}
                        <div className="p-6">

                            <div className="rounded-xl border border-slate-200 bg-slate-50 p-5">

                                <div className="space-y-4">

                                    <div className="flex justify-between">
                                        <span className="text-slate-500">Order ID</span>
                                        <span className="font-semibold">
                                            #{paymentResp?.rzp_payment.razorpayOrderId || ""}
                                        </span>
                                    </div>

                                    <div className="flex justify-between">
                                        <span className="text-slate-500">Payment ID</span>
                                        <span className="font-semibold">
                                            #{paymentResp?.rzp_payment.razorpayPaymentId || ""}
                                        </span>
                                    </div>

                                    <div className="flex justify-between">
                                        <span className="text-slate-500">Plan</span>
                                        <span className="font-semibold">
                                            {selectedPlan?.name || ''}
                                        </span>
                                    </div>

                                    <div className="flex justify-between">
                                        <span className="text-slate-500">Amount</span>
                                        <span
                                            className={`font-bold ${paymentStatus === "success"
                                                ? "text-green-600"
                                                : "text-red-600"
                                                }`}
                                        >
                                            ₹{paymentResp?.rzp_payment.amount || 0}
                                        </span>
                                    </div>

                                    <div className="flex justify-between">
                                        <span className="text-slate-500">Status</span>

                                        <span
                                            className={`rounded-full px-3 py-1 text-sm font-semibold`}
                                        >
                                            {paymentResp?.rzp_payment.status || ''}
                                        </span>
                                    </div>

                                </div>

                            </div>

                            {/* Message */}
                            <div
                                className={`mt-5 rounded-xl p-4`}
                            >
                                <div className="flex items-start gap-3">



                                    <div>
                                        <h4
                                            className={`font-semibold text-center ${paymentStatus === "success"
                                                ? "text-green-700"
                                                : "text-red-700"
                                                }`}
                                        >
                                            <i
                                                className={`fas ${paymentStatus === "success"
                                                    ? "fa-envelope text-green-600"
                                                    : "fa-triangle-exclamation text-red-600"
                                                    } text-xl`}
                                            ></i> {paymentStatus === "success"
                                                ? "Invoice Sent"
                                                : "Payment Failed"}
                                        </h4>

                                        <p className="mt-1 text-sm text-slate-600">
                                            {paymentStatus === "success"
                                                ? "Your invoice has been sent to your registered email."
                                                : "Your payment could not be completed. Please retry or use another payment method."}
                                        </p>
                                    </div>

                                </div>
                            </div>

                            {/* Buttons */}
                            <div className="mt-6 flex gap-3">

                                {paymentStatus === "success" ? (
                                    <>
                                        <button className="flex-1 rounded-xl bg-indigo-600 py-2.5 font-semibold text-white hover:bg-indigo-700" onClick={() => handleRoute("/app/dashboard")}>
                                            <i className="fas fa-home mr-2"></i>
                                            Dashboard
                                        </button>

                                        <button className="flex-1 rounded-xl border py-2.5 font-semibold hover:bg-slate-50">
                                            <i className="fas fa-download mr-2"></i>
                                            Invoice
                                        </button>
                                    </>
                                ) : (
                                    <>
                                        <button className="flex-1 rounded-xl bg-red-600 py-2.5 font-semibold text-white hover:bg-red-700">
                                            <i className="fas fa-rotate-right mr-2"></i>
                                            Retry Payment
                                        </button>

                                        <button className="flex-1 rounded-xl border py-2.5 font-semibold hover:bg-slate-50">
                                            <i className="fas fa-arrow-left mr-2"></i>
                                            Back to Plans
                                        </button>
                                    </>
                                )}

                            </div>

                        </div>
                    </div>
                </div>

            ) : (
                <>
                    <div className="max-w-6xl mx-auto bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden">


                        {/* Header */}
                        <div className="flex items-center justify-between border-b border-slate-100 px-6 py-4 sm:px-8">
                            <div className="flex items-center gap-4">
                                {/* Example usage of the back arrow icon if needed */}
                                <button className="text-slate-400 hover:text-slate-600 transition-colors">
                                    <i className="fas fa-arrow-left text-sm" onClick={() => handleRoute("/pricing")}></i>
                                </button>
                                <div>
                                    <h1 className="text-3xl font-extrabold text-slate-900 tracking-tight">Checkout</h1>
                                    <p className="text-slate-500 mt-1">Complete your purchase and enjoy all premium features</p>
                                </div>
                            </div>

                        </div>

                        {/* Main Content Body */}
                        <div className="p-6 sm:p-8 lg:p-10 grid grid-cols-1 lg:grid-cols-12 gap-8">

                            {/* Left Column: Plan & Billing Details */}
                            <div className="lg:col-span-7 space-y-8">

                                {/* Pro Plan Feature Box */}
                                <div className="border border-slate-100 rounded-2xl p-6 relative overflow-hidden bg-gradient-to-br from-white to-slate-50/50">
                                    {/* Decorative Mock Illustration Graphic */}
                                    <div className="absolute top-6 right-6 hidden sm:block w-32 h-24 rounded-xl shadow-xl transform rotate-3 origin-bottom-right p-2 border border-white/20 bg-gradient-to-br from-[#232298] via-indigo-600 to-[#fe833d]">

                                        {/* Top Dots */}
                                        <div className="flex gap-1 mb-2">
                                            <div className="w-2 h-2 rounded-full bg-white/90"></div>
                                            <div className="w-2 h-2 rounded-full bg-white/70"></div>
                                            <div className="w-2 h-2 rounded-full bg-white/50"></div>
                                        </div>

                                        {/* Content */}
                                        <div className="space-y-1.5">
                                            <div className="h-2 w-3/4 rounded bg-white/35"></div>
                                            <div className="h-2 w-5/6 rounded bg-white/25"></div>

                                            <div className="flex h-6 items-end rounded bg-black/10 p-1">
                                                <div className="h-2 w-full rounded-sm bg-gradient-to-r from-cyan-300 via-sky-400 to-white"></div>
                                            </div>
                                        </div>

                                        {/* Premium Badge */}
                                        <div className="absolute -top-3 -right-3 flex h-7 w-7 items-center justify-center rounded-full bg-gradient-to-br from-yellow-300 to-orange-500 shadow-lg ring-2 ring-white">
                                            👑
                                        </div>

                                    </div>

                                    {/* Plan Details */}
                                    <div className="space-y-2 max-w-sm">
                                        <div className="flex items-center gap-2">
                                            <span className="text-xl">🚀</span>
                                            <h3 className="text-xl font-bold text-slate-900">{selectedPlan.name}</h3>
                                        </div>
                                        <div className="flex items-baseline gap-1">
                                            <span className="text-2xl font-extrabold text-indigo-600">₹{selectedPlan.price.monthly}</span>
                                            <span className="text-indigo-600 font-semibold text-sm">/ {selectedPlan.price.monthly ? 'Monthly' : 'Yearly'}</span>
                                        </div>
                                        <p className="text-sm text-slate-500 Antique leading-relaxed">
                                            {selectedPlan.description}
                                        </p>
                                    </div>

                                    <hr className="my-5 border-slate-100" />

                                    {/* Features Checklist */}
                                    <ul className="space-y-3.5">
                                        {selectedPlan.features.map((feature, index) => (
                                            <li
                                                key={index}
                                                className="flex items-center gap-3 text-sm font-semibold text-slate-700"
                                            >
                                                <i
                                                    className={`fas ${feature.included
                                                        ? "fa-check-circle text-indigo-600"
                                                        : "fa-times-circle text-red-500"
                                                        } text-base`}
                                                ></i>

                                                <span
                                                    className={
                                                        feature.included
                                                            ? "text-slate-700"
                                                            : "text-slate-400 line-through"
                                                    }
                                                >
                                                    {feature.text}
                                                </span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>

                                {/* Billing Details Form */}
                                <div>
                                    <h3 className="text-base font-bold text-slate-900 mb-4">
                                        Billing Details
                                    </h3>

                                    <div className="space-y-6">

                                        {/* Contact Person */}
                                        <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                                            <h3 className="mb-5 text-lg font-bold text-slate-900">
                                                Contact Person Details
                                            </h3>

                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">

                                                <div>
                                                    <p className="text-xs font-medium uppercase tracking-wide text-slate-500">
                                                        First Name
                                                    </p>
                                                    <p className="mt-1 text-base font-semibold text-slate-900">
                                                        {user?.first_name || "-"}
                                                    </p>
                                                </div>

                                                <div>
                                                    <p className="text-xs font-medium uppercase tracking-wide text-slate-500">
                                                        Last Name
                                                    </p>
                                                    <p className="mt-1 text-base font-semibold text-slate-900">
                                                        {user?.last_name || "-"}
                                                    </p>
                                                </div>

                                                <div>
                                                    <p className="text-xs font-medium uppercase tracking-wide text-slate-500">
                                                        Email
                                                    </p>
                                                    <p className="mt-1 text-base font-semibold text-slate-900">
                                                        {user?.email || "-"}
                                                    </p>
                                                </div>

                                                <div>
                                                    <p className="text-xs font-medium uppercase tracking-wide text-slate-500">
                                                        Phone
                                                    </p>
                                                    <p className="mt-1 text-base font-semibold text-slate-900">
                                                        {user?.phone || "-"}
                                                    </p>
                                                </div>

                                            </div>
                                        </div>

                                        {/* Organization */}
                                        <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                                            <h3 className="mb-5 text-lg font-bold text-slate-900">
                                                Organization Details
                                            </h3>

                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">

                                                <div>
                                                    <p className="text-xs font-medium uppercase tracking-wide text-slate-500">
                                                        Company Name
                                                    </p>
                                                    <p className="mt-1 text-base font-semibold text-slate-900">
                                                        {user?.organization?.name || "-"}
                                                    </p>
                                                </div>

                                                <div>
                                                    <p className="text-xs font-medium uppercase tracking-wide text-slate-500">
                                                        GST Number
                                                    </p>
                                                    <p className="mt-1 text-base font-semibold text-slate-900">
                                                        {user?.organization?.gst_number || "-"}
                                                    </p>
                                                </div>

                                                <div className="md:col-span-2">
                                                    <p className="text-xs font-medium uppercase tracking-wide text-slate-500">
                                                        Address
                                                    </p>
                                                    <p className="mt-1 text-base font-semibold text-slate-900">
                                                        {user?.organization?.address || "-"}
                                                    </p>
                                                </div>

                                                <div>
                                                    <p className="text-xs font-medium uppercase tracking-wide text-slate-500">
                                                        Country
                                                    </p>
                                                    <p className="mt-1 text-base font-semibold text-slate-900">
                                                        {user?.organization?.country || "-"}
                                                    </p>
                                                </div>

                                                <div>
                                                    <p className="text-xs font-medium uppercase tracking-wide text-slate-500">
                                                        State
                                                    </p>
                                                    <p className="mt-1 text-base font-semibold text-slate-900">
                                                        {user?.organization?.state || "-"}
                                                    </p>
                                                </div>

                                                <div>
                                                    <p className="text-xs font-medium uppercase tracking-wide text-slate-500">
                                                        City
                                                    </p>
                                                    <p className="mt-1 text-base font-semibold text-slate-900">
                                                        {user?.organization?.city || "-"}
                                                    </p>
                                                </div>

                                                <div>
                                                    <p className="text-xs font-medium uppercase tracking-wide text-slate-500">
                                                        Pincode
                                                    </p>
                                                    <p className="mt-1 text-base font-semibold text-slate-900">
                                                        {user?.organization?.pincode || "-"}
                                                    </p>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                </div>

                                {/* Bottom Footer Info */}
                                <div className="flex items-center gap-2 text-xs font-medium text-slate-400 pt-2">
                                    <div className="p-1 bg-slate-100 rounded flex items-center justify-center w-6 h-6">
                                        <i className="fas fa-shield-halved text-slate-400 text-xs"></i>
                                    </div>
                                    <span>Your information is secure and encrypted</span>
                                </div>
                            </div>

                            {/* Right Column: Order Summary & Payment */}
                            <div className="lg:col-span-5">
                                <div className="border border-slate-100 rounded-2xl p-6 space-y-6 bg-white">

                                    {/* Summary Calculations */}
                                    <div>
                                        <h3 className="text-base font-bold text-slate-900 mb-4">Order Summary</h3>
                                        <div className="space-y-3 text-sm font-medium">
                                            <div className="flex justify-between text-slate-600">
                                                <span>Plan Price</span>
                                                <span className="text-slate-900">₹{planPrice.toFixed(2)}</span>
                                            </div>
                                            <div className="flex justify-between text-slate-600">
                                                <span>GST (({gstRate}%))</span>
                                                <span className="text-slate-900">₹{gstAmount.toFixed(2)}</span>
                                            </div>
                                            <div className="flex justify-between text-emerald-600">
                                                <span>Discount ({discountPercentage}%)</span>
                                                <span>-₹{discountAmount}</span>
                                            </div>
                                            <hr className="border-slate-100 my-2" />
                                            <div className="flex justify-between items-baseline pt-1">
                                                <span className="text-base font-bold text-slate-900">Total</span>
                                                <span className="text-xl font-extrabold text-slate-900">₹{total.toFixed(2)}</span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Coupon Section */}
                                    <div>
                                        <label className="block text-xs font-bold text-slate-700 mb-1.5">Coupon</label>
                                        <div className="flex gap-2">
                                            <input
                                                type="text"
                                                value={coupon}
                                                onChange={(e) => setCoupon(e.target.value)}
                                                placeholder="Enter coupon code"
                                                className="flex-1 px-3.5 py-2 bg-white border border-slate-200 rounded-xl text-sm font-medium focus:outline-none focus:border-indigo-500 transition-all"
                                            />
                                            <button type="button" className="px-5 py-2 border border-indigo-200 text-indigo-600 rounded-xl text-sm font-semibold hover:bg-indigo-50 transition-colors">
                                                Apply
                                            </button>
                                        </div>
                                    </div>

                                    {/* Payment Methods selector */}
                                    {/* <div>
                                <label className="block text-xs font-bold text-slate-700 mb-2">Payment Method</label>
                                <div className="border border-slate-200 rounded-xl divide-y divide-slate-100 overflow-hidden">

                                    <label className={`flex items-center justify-between p-3.5 cursor-pointer transition-colors ${paymentMethod === 'card' ? 'bg-slate-50/50' : 'bg-white'}`}>
                                        <div className="flex items-center gap-3">
                                            <input
                                                type="radio"
                                                name="payment"
                                                checked={paymentMethod === 'card'}
                                                onChange={() => setPaymentMethod('card')}
                                                className="w-4 h-4 text-indigo-600 border-slate-300 focus:ring-indigo-500"
                                            />
                                            <span className="text-sm font-semibold text-slate-800">Credit / Debit Card</span>
                                        </div>
                                        <i className="fas fa-credit-card text-slate-800"></i>
                                    </label>

                                    <label className={`flex items-center justify-between p-3.5 cursor-pointer transition-colors ${paymentMethod === 'upi' ? 'bg-slate-50/50' : 'bg-white'}`}>
                                        <div className="flex items-center gap-3">
                                            <input
                                                type="radio"
                                                name="payment"
                                                checked={paymentMethod === 'upi'}
                                                onChange={() => setPaymentMethod('upi')}
                                                className="w-4 h-4 text-indigo-600 border-slate-300 focus:ring-indigo-500"
                                            />
                                            <span className="text-sm font-semibold text-slate-800">UPI</span>
                                        </div>
                                        <span className="text-xs font-bold italic tracking-wider text-slate-600 bg-slate-100 px-1.5 py-0.5 rounded">UPI</span>
                                    </label>

                                    <label className={`flex items-center justify-between p-3.5 cursor-pointer transition-colors ${paymentMethod === 'netbanking' ? 'bg-slate-50/50' : 'bg-white'}`}>
                                        <div className="flex items-center gap-3">
                                            <input
                                                type="radio"
                                                name="payment"
                                                checked={paymentMethod === 'netbanking'}
                                                onChange={() => setPaymentMethod('netbanking')}
                                                className="w-4 h-4 text-indigo-600 border-slate-300 focus:ring-indigo-500"
                                            />
                                            <span className="text-sm font-semibold text-slate-800">Net Banking</span>
                                        </div>
                                        <i className="fas fa-building-columns text-slate-400"></i>
                                    </label>

                                </div>
                            </div> */}

                                    <div className="space-y-4">
                                        <button type="button" className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-3.5 px-4 rounded-xl flex items-center justify-center gap-2 shadow-sm transition-all focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2" onClick={() => handleSubscribe(selectedPlan)}
                                            disabled={loading}>
                                            <i className="fas fa-lock text-sm"></i>
                                            <span>Proceed to Checkout</span>
                                        </button>

                                        {/* <button
                                    className={`subscribe-btn ${plan.popular ? 'primary' : 'secondary'}`}
                                    onClick={() => handleSubscribe(plan)}
                                    disabled={loading}
                                >
                                    {plan.type === 'free' ? 'Get Started' : 'Subscribe Now'}
                                </button> */}

                                        {/* <div className="flex items-center justify-center gap-2 text-[11px] font-medium text-slate-400">
                                    <i className="fas fa-shield-halved text-slate-400"></i>
                                    <span>Secure payments powered by SSL encryption</span>
                                </div>

                                <div className="flex items-center justify-center gap-5 pt-2 opacity-60 filter grayscale hover:grayscale-0 transition-all">
                                    <span className="text-xs font-black italic tracking-tighter text-blue-800">VISA</span>
                                    <span className="text-xs font-bold text-red-500">mastercard</span>
                                    <span className="text-xs font-extrabold tracking-tight text-slate-700">RuPay▶</span>
                                    <span className="text-xs font-bold italic text-slate-500">UPI</span>
                                </div> */}
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </>
            )}

        </div>
    );
}

export default CheckoutPage;
